import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { isNotEmptyObject } from "../../../utils/jsonValidator";
import { useDataAuth } from "../../../hooks/useDataAuth";

export function useApiTrigger(config, filters = {}) {
    const [{ userSession }] = useDataAuth();
    const [dto, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const triggerApi = useCallback(async () => {
        if (!config?.trigger?.length) return;
        const apiConfig = config.trigger[0];
        setLoading(true);
        setError(null);
        try {
            let bodyData = apiConfig.bodyData
            if (isNotEmptyObject(filters))
                bodyData.variables = JSON.stringify({ filters });
            const response = await axios({
                method: apiConfig.method,
                url: apiConfig.url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userSession?.token}`
                },
                data: bodyData,
            });
            const normalizeData = (data) => {
                if (!data) return [];
                if (Array.isArray(data)) return data;
                if (typeof data === 'object') return [data];
                return [];
            };
            setData(normalizeData(response?.data));
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [config, filters, userSession?.token]);

    useEffect(() => {
        triggerApi();
    }, [triggerApi]);
    return { dto, loading, error, refetch: triggerApi };
}
